export default __webpack_public_path__ + "static/media/guitar.f2e06451.svg";